import React from "react";
import "./PeakHours.css";

import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";

const PeakHours = ({ peakHours }) => {
  const chartData = Array.from(
    { length: 24 },
    (_, hour) => {
      const found = peakHours.find(
        (item) => item._id === hour
      );

      return {
        hour: `${hour}:00`,
        orders: found ? found.orders : 0,
      };
    }
  );

  const busiestHour = chartData.reduce(
    (max, item) =>
      item.orders > max.orders ? item : max,
    chartData[0]
  );

  return (
    <div className="peak-hours">

      <div className="peak-header">

        <div>
          <h2>🕒 Peak Order Hours</h2>
          <p>Orders received throughout the day</p>
        </div>

        <div className="peak-badge">
          Peak: {busiestHour.hour}
        </div>

      </div>

      <ResponsiveContainer
        width="100%"
        height={350}
      >
        <BarChart data={chartData}>

          <CartesianGrid strokeDasharray="3 3" />

          <XAxis
            dataKey="hour"
            interval={1}
            angle={-45}
            textAnchor="end"
            height={60}
          />

          <YAxis />

          <Tooltip />

          <Legend />

          <Bar
            dataKey="orders"
            name="Orders"
            radius={[8, 8, 0, 0]}
          />

        </BarChart>
      </ResponsiveContainer>

    </div>
  );
};

export default PeakHours;